import { Step } from "../../../types/Step";
import AllMedicalQuestionsEvaluator from "../../Steps/Medical/Compositions/AllMedicalQuestionsEvaluator";
import { INavigatorItemConfig } from "../Components/Navigator";
import NavigatorItemId from "../Types/NavigatorItemId";

const ScreeningNavigatorConfiguration: INavigatorItemConfig = {
  id: NavigatorItemId.Screening,
  label: "Screening",
  isDisabled: () => false,
  onClickStep: Step.qualify,
  lastStep: Step.medicalDiabetic
};

const SchedulingNavigatorConfiguration: INavigatorItemConfig = {
  isDisabled: ({ medicalForm }) =>
    !AllMedicalQuestionsEvaluator.isComplete(medicalForm) || AllMedicalQuestionsEvaluator.isNonCandidate(medicalForm),
  id: NavigatorItemId.Scheduling,
  label: "Scheduling",
  onClickStep: Step.centerSelection,
  lastStep: Step.scheduling
};

const ConfirmationNavigatorConfiguration: INavigatorItemConfig = {
  isDisabled: ({ reservation }) => !reservation,
  id: NavigatorItemId.Confirmation,
  label: "Confirmation",
  onClickStep: Step.confirmation,
  lastStep: Step.confirmation
};

/** The default navigator configuration for the application. It includes the qualify, scheduling, and confirmation
 *  navigator items.
 */
export const DefaultNavigatorConfiguration: INavigatorItemConfig[] = [
  ScreeningNavigatorConfiguration,
  SchedulingNavigatorConfiguration,
  ConfirmationNavigatorConfiguration
];

/** The navigator configuration that should only be used when the customer is pre-qualified for the booking process. */
export const PreQualifiedCustomerNavigatorConfiguration: INavigatorItemConfig[] = [
  SchedulingNavigatorConfiguration,
  ConfirmationNavigatorConfiguration
];

/** The default navigator configuration for the no-confirmation variant (books directly from scheduling). */
export const NoConfirmationDefaultNavigatorConfiguration: INavigatorItemConfig[] = [
  ScreeningNavigatorConfiguration,
  SchedulingNavigatorConfiguration
];

/** The navigator configuration for pre-qualified customers in the no-confirmation variant. */
export const NoConfirmationPreQualifiedCustomerNavigatorConfiguration: INavigatorItemConfig[] = [
  SchedulingNavigatorConfiguration
];
